/*
 * This is hard-coded just for Gemini because we have not implemented pulling server-side tools into the definition yet.
 * This will become stale quickly. It can be copied from the response in /api/ada/pro/sessions/?org_id=X.  This can use
 * the OpenAI format for function calls even though this is only loaded for Geomini, because it will be transformed
 * after loading anyway.
 */
export const SERVER_SIDE_TOOLS = [
  {
    name: 'geocode_address',
    description:
      'Find the longitude, latitude and structured address parts for a street address query ONLY when creating a new project. Do not use this to search for existing projects/records. If multiple results are returned you will need to clarify which is the correct result. The first result is generally the best result.',
    parameters: {
      type: 'object',
      properties: {
        address: {
          type: 'string',
          description:
            'Full home or business address. For example: "1600 California St, Berkeley CA 94703, US". Address should contain enough detail to identify the property but it does not always need to include all these elements in a particular order. If the result location_type is not equal to "ROOFTOP" then give the user a chance to clarify the address before proceeding with system design.',
        },
      },
      required: ['address'],
      additionalProperties: false,
    },
    type: 'function',
  },
  //   {
  //     name: 'create_project_and_design_systems_at_address',
  //     description:
  //       'Design systems at specified longitude and latitude. Do not populate dummy or sample values. If a field is unknown just omit it. The response should include a) confirmation of whether the project was created or if more info is required to proceed. If project was created, the response should include the address, the project id that was created, and navigate the app to the created project id by including a json client with action.navigate in the response. When the user is in studio (APP_STATE.pathname matches `/projects/{project_id}/design`), you should not call this tool. Instead, you should return a client-side action that includes one system template in the system_templates array. i.e. {"action": "autoDesignEphemeral", "args": {"system_templates_json": [{...system_template_data}]}}}. If APP_STATE.pathname is unknown then call create_project_and_design_systems_at_address instead of autoDesignEphemeral. Do not hallucinate system_template_data, only call autoDesignEphemeral AFTER you have loaded a system templat',
  //     parameters: {
  //       type: 'object',
  //       properties: {
  //         id: {
  //           type: ['integer', 'null'],
  //           description: 'project_id if we want to target an existing project. Omit if we want to create a new project.',
  //         },
  //         lon: {
  //           type: ['number', 'null'],
  //           description:
  //             'Longitude. e.g. -122.280822. Can be omitted if id is specified, unless you need to update lon on the existing project. ',
  //         },
  //         lat: {
  //           type: ['number', 'null'],
  //           description:
  //             'Latitude. e.g. 37.876799. Can be omitted if id is specified, unless you need to update lat on the existing project.',
  //         },
  //         address: {
  //           type: ['string', 'null'],
  //           description:
  //             'Street number, street name and street type combined into a single string. e.g. "1600 California St"',
  //         },
  //         state: {
  //           type: ['string', 'null'],
  //           description: 'State, expressed as an abbreviation, if possible. e.g. "CA"',
  //         },
  //         country_iso2: {
  //           type: ['string', 'null'],
  //           description: 'Country in 2-letter ISO2 format. e.g. "US"',
  //         },
  //         zip: {
  //           type: ['string', 'null'],
  //           description: 'Zipcode/Postcode. e.g. "94703"',
  //         },
  //         locality: {
  //           type: ['string', 'null'],
  //           description: 'City or Town or Suburb.. e.g. "Berkeley"',
  //         },
  //         overwrite_existing_designs: {
  //           type: 'boolean',
  //           description:
  //             'Determine whether to allow overwriting existing system designs if they already exist. Otherwise, any existing designs will be retained and not overwritten. If true: allow overwriting. If false: retain existing systems if they exist. Default to false unless the user explicitly confirms they want to overwrite existing designs.',
  //         },
  //         system_templates: {
  //           type: 'array',
  //           description:
  //             "List of system template objects. Each object can optionally include an 'id' to load an existing system template, and any other keys to set or override its values. You should *almost always* load a saved system template record as a starting point for a system template, and you can make any customizations after that. This avoids omitting important data. If user indicates certain preferences or constraints, use one or more existing system templates and augment them to include the requested change. e.g. If user says to design with max modules of 10, use an existing system template and then override the module_quantity constraint.",
  //           items: {
  //             type: 'object',
  //             description:
  //               "A system template object. If 'id' is not provided, then additional keys should be included to define the template including some mandatory keys which are: modules under `components_and_quantities[n][type='module'].code` .",
  //             properties: {
  //               id: {
  //                 type: ['integer', 'null'],
  //                 description:
  //                   'Existing system template id. Populate id if known so we can retrieve other properties from the saved system template. If id it not know, set value to null and ensure all other other properties are provided.',
  //               },
  //               calculator_id: {
  //                 type: 'integer',
  //                 description: 'calculator_id for the calculator to be used.',
  //               },
  //               uuid: {
  //                 type: 'string',
  //                 description: 'Unique identifier for the system template.',
  //               },
  //               name: {
  //                 type: 'string',
  //                 description: 'Name of the system template.',
  //               },
  //               components_and_quantities: {
  //                 type: 'array',
  //                 description:
  //                   'List of components and their associated quantities for the system template. Only add items that have a specified code, do not add items with dummy or sample codes. If system_template_id is not supplied it is critical to include the module component with a *code* field populated.',
  //                 items: {
  //                   type: 'object',
  //                   properties: {
  //                     component_type: {
  //                       type: 'string',
  //                       description: 'Type of the solar component.',
  //                       enum: ['module', 'inverter', 'battery', 'other'],
  //                     },
  //                     code: {
  //                       type: 'string',
  //                       description: 'Component code. Do not fill with a dummy value if it is not known.',
  //                     },
  //                     quantity: {
  //                       type: 'integer',
  //                       description:
  //                         "Quantity of the component required. This must not be set for 'module' components. To set the quantity for 'module' components, set constraints['module_quantity'][[{min}, {max}]",
  //                     },
  //                   },
  //                   required: ['component_type', 'code', 'quantity'],
  //                   additionalProperties: false,
  //                 },
  //               },
  //               inverter_design_assistant: {
  //                 description:
  //                   'Allows automatically including an inverter recommendation. If user has not request an inverter recommendation then leave this value as: null',
  //                 type: ['object', 'null'],
  //                 properties: {
  //                   inverter_type: {
  //                     type: 'string',
  //                     enum: ['string', 'power_optimized', 'microinverter', 'hybrid'],
  //                   },
  //                 },
  //                 required: ['inverter_type'],
  //                 additionalProperties: false,
  //               },
  //               battery_design_assistant: {
  //                 description:
  //                   'Populate this value if the user wants to receive a battery recommendation, otherwise set to null. Before providing a recommendation, ask customer to indicate a value for all battery_design_assistant fields.',
  //                 type: ['object', 'null'],
  //                 properties: {
  //                   customer_goal: {
  //                     type: 'string',
  //                     enum: ['maximize_savings', 'self_consumption', 'peak_demand_shaving'],
  //                   },
  //                   backup_hours: {
  //                     type: ['number', 'null'],
  //                     description: 'Optional. Represents backup hours; can be null.',
  //                   },
  //                   continuous_power_kw: {
  //                     type: ['number', 'null'],
  //                     description: 'Optional. Represents continuous power in kW; can be null.',
  //                   },
  //                   peak_power_kw: {
  //                     type: ['number', 'null'],
  //                     description: 'Optional. Represents peak power in kW; can be null.',
  //                   },
  //                   codes: {
  //                     type: 'array',
  //                     items: {
  //                       type: 'string',
  //                     },
  //                     description:
  //                       'Required list of battery codes. If no items are included then the battery design assistant is effectively disabled.',
  //                   },
  //                 },
  //                 required: ['customer_goal', 'backup_hours', 'continuous_power_kw', 'peak_power_kw', 'codes'],
  //                 additionalProperties: false,
  //               },
  //               pricing_scheme_id: {
  //                 type: ['number', 'null'],
  //                 description: 'ID of the pricing scheme to be applied.',
  //               },
  //               payment_options_override: {
  //                 type: 'array',
  //                 description: 'List of payment option IDs that override default settings.',
  //                 items: {
  //                   type: 'number',
  //                 },
  //               },
  //               azimuth_from_to: {
  //                 type: 'array',
  //                 description:
  //                   'Azimuth range values as a two-item array [from, to]. To avoid any constraints on azimuth, set to [0, 0].',
  //                 items: {
  //                   type: 'number',
  //                 },
  //               },
  //               constraints: {
  //                 type: 'array',
  //                 description: 'List of constraint objects that define limits for the system template.',
  //                 items: {
  //                   type: 'object',
  //                   properties: {
  //                     type: {
  //                       type: 'string',
  //                       description:
  //                         'Type of constraint. Only set module_quantity_per_array if the user is clear they are talking about quantity *per array* otherwise they are almost always referring to *module_quantity*.',
  //                       enum: ['annual_kwh', 'module_quantity', 'module_quantity_per_array'],
  //                     },
  //                     min: {
  //                       anyOf: [
  //                         {
  //                           type: 'number',
  //                         },
  //                         {
  //                           type: 'null',
  //                         },
  //                       ],
  //                       description: 'Minimum value for the constraint. Set to null if there is not min constraint.',
  //                     },
  //                     max: {
  //                       anyOf: [
  //                         {
  //                           type: 'number',
  //                         },
  //                         {
  //                           type: 'null',
  //                         },
  //                       ],
  //                       description: 'Maximum value for the constraint. Set to null if there is no max constraint.',
  //                     },
  //                   },
  //                   required: ['type', 'min', 'max'],
  //                   additionalProperties: false,
  //                 },
  //               },
  //             },
  //             required: [
  //               'id',
  //               'calculator_id',
  //               'uuid',
  //               'name',
  //               'components_and_quantities',
  //               'pricing_scheme_id',
  //               'payment_options_override',
  //               'azimuth_from_to',
  //               'constraints',
  //               'inverter_design_assistant',
  //               'battery_design_assistant',
  //             ],
  //             additionalProperties: false,
  //           },
  //         },
  //       },
  //       required: [
  //         'id',
  //         'lon',
  //         'lat',
  //         'address',
  //         'state',
  //         'country_iso2',
  //         'zip',
  //         'locality',
  //         'overwrite_existing_designs',
  //         'system_templates',
  //       ],
  //       additionalProperties: false,
  //     },
  //     type: 'function',
  //   },
  {
    name: 'search_records',
    description:
      "Search/filter records matching the specified record_type and parameters. Use this to respond to requests to show/list/search/filter a set of records. *Always mention the 'id' field for each record in the response, if available, which is helpful for navigating the app to view/show/edit the record later*. If a matching 'extra' filter is found then add the filter to the 'extra' filters instead of the regular 'search' filter. The response format is: {'records': [list of records], 'content_range': '{start}-{end}/{total}'}. If we retrieved a set of results that is not the full result set (i.e. if {end} is not equal to {total}) then include a summary based on the content-range (e.g. 'Showing {content_range.start}-{content_range.end} of {content_range.total} records').",
    parameters: {
      type: 'object',
      properties: {
        record_type: {
          type: 'string',
          description:
            'Common record_types are: projects, contacts, components (which includes various types such as solar panels, batteries, etc), system_templates. The full list of record_types (followed by a description and optional "extra" filters) is:\n\n*Top Priority Org-level records*\nprojects: "Project" with extra filters:\n    - zip (use for zip/zipcode/postcode)\n    - locality (use this filter when user specifies a city/town/suburb or if they say something like "project in {locality}" or "project near {locality}")\ncontacts: Contact\ncomponents: Components\nsystem_templates: System Template (for auto-design)\n\n*Other Org-level records*\nactions: Action\nadders: Adder\nbattery_schemes: Battery Scheme\ncommissions: Commission\ncomponent_battery_activations: Component Battery Activation\ncomponent_content: Component Content\ncomponent_inverter_activations: Component Inverter Activation\ncomponent_module_activations: Component Module Activation\ncomponent_other_activations: Component Other Activation\ncontracts: Contract\ncostings: Costing\ncustom_fields: Custom Field\ncustom_forms: Form\ndocument_templates: Document Template\nevents: Event\nincentives: Incentive\ninventory_activity: Inventory Activity\ninventory_locations: Inventory Location\ninventory_transfer_line_items: Inventory Transfer Line Item\ninventory_transfers: Inventory Transfer\ninvoices: Invoice\npayment_options: "Payment Option" with extra filters:\n    - payment_type: permitted values: "cash", "loan", "loan_advanced", "ppa", "regular_payment", "lease"\npermissions_role: Permissions Role\npricing_schemes: "Pricing Scheme" with extra filters:\n    - pricing_formula: permitted values: "Markup Percentage", "Price Per Watt", "Price Per Watt By Size", "Fixed Price"\nprivate_files: My Private File\nproject_configurations: Project Configuration\nproposal_templates: Proposal Template\npublic_files: Public File\nroles: Role\nsystems: System\ntags: Tag\ntestimonials: Testimonial\ntransactions: Transaction\nutility_tariffs: Utility Tariff\nviews: Org Project View\nwebhooks: Webhook\nworkflows: Workflow\n\n*System-wide records*\ncomponent_batteries: Component Battery\ncomponent_inverters: Component Inverter\ncomponent_modules: Component Module\ncomponent_others: Component Other\ndistributors: Distributor\nfile_tags: File Tag\nmanufacturers: Manufacturer\nroof_types: Roof Type\nutilities: Utility\n                        ',
        },
        search: {
          type: ['string', 'null'],
          description:
            'Search string to filter objects. Matches various useful fields depending on record type. If a filter is available use add the filter to the "extra" params instead of using this generic search filter.',
        },
        id: {
          type: 'integer',
          description: 'Integer identifier to filter objects.',
        },
        limit: {
          type: ['integer', 'null'],
          description: 'Max records to return per page of results.',
        },
        page: {
          type: ['integer', 'null'],
          description:
            'The page number for pagination. Always start on page 1, or leave blank. Only fetch additional pages if requsted.',
        },
        ordering: {
          type: ['string', 'null'],
          description:
            "Fieldname with optional '-' prefix to sort by descending order. e.g. 'id' or 'id'. Only include if the field is known to be supported by this record.",
        },
        // extra: {
        //   type: ['object', 'null'],
        //   description:
        //     "A flexible dictionary of additional filters where the keys and values are dynamically determined to refine the search. Available keys are specific to each record type. For example 'zip' for projects. If a matching 'extra' filter is found then add the filter to the 'extra' filters instead of the regular 'search' filter.",
        // },
      },
      //    extra "object" type not supported by Gemini
      required: ['record_type', 'search', 'limit', 'page', 'ordering'],
      //   required: ['record_type', 'search', 'limit', 'page', 'ordering', 'extra'],
      //   additionalProperties: false,
    },
    type: 'function',
  },
  {
    name: 'proposal_data',
    description:
      'Load solar electification proposal to a customer so they can understand their system options, and the benefits and costs of each option. Includes: hardware components, power generation & performance, environmental benefits, financial benefits, price, payment and financing options, and more. Generally it can be assumed that the components used in this proposal are high quality because they have been selected by a solar professional. The customer already has access to the full information in the proposal so you should answer their questions concisely without providing long summaries of the system options.',
    parameters: {
      type: 'object',
      properties: {
        project_id: {
          type: 'integer',
          description: 'project_id',
        },
      },
      required: ['project_id'],
      additionalProperties: false,
    },
    type: 'function',
  },
  {
    name: 'submit_site_visit',
    description:
      'Record details from a home/site visit that will affect the solar electrification solution and installation. Ideally this tool will be called once all fields have been collected, but it can also be submitted once any of the fields have been collected. Always confirm with the customer before submitting to avoid accidentally updating incorrect data. Do not tell the user you are saving/submitting/updating/recording/storing the site visit details unless you use this tool.',
    parameters: {
      type: 'object',
      properties: {
        project_id: {
          type: 'string',
          description: 'The ID of the project to record the site visit for',
        },
        site_notes: {
          type: 'string',
          description: 'Detailed notes from the site visit',
        },
        roof_type: {
          type: 'string',
          description:
            "Type of roof observed during the visit. If the specified roof type is ambiguous then confirm the correct choice with the user before submitting. e.g. If the user specifies 'Tile' then confirm if it is 'Tile Clay', 'Tile Concrete', or 'Tile Slate'.",
          enum: [
            'Composition / Asphalt Shingle',
            'Flat Concrete',
            'Flat Foam',
            'Kliplock',
            'Membrane EPDM',
            'Membrane PVC',
            'Membrane TPO',
            'Metal Decramastic',
            'Metal Shingle',
            'Metal Standing Seam',
            'Metal Stone Coated',
            'Metal Tin',
            'Other',
            'Rolled Asphalt',
            'Tar and Gravel / Bitumen',
            'Thatched',
            'Tile Clay',
            'Tile Concrete',
            'Tile Slate',
            'Trapezoidal',
            'Wood/Shake Shingle',
          ],
        },
        number_of_storeys: {
          type: 'integer',
          description: 'Number of storeys in the building',
        },
        number_of_phases: {
          type: 'integer',
          description: 'Number of electrical phases at the site',
        },
        number_of_wires: {
          type: 'integer',
          description: 'Number of electrical wires at the site',
        },
        meter_identifier: {
          type: 'string',
          description: 'Unique identifier for the electrical meter',
        },
        parcel_identifier: {
          type: 'string',
          description: 'Property parcel identifier',
        },
        has_cellular_coverage: {
          type: 'string',
          description: 'Whether the site has cellular coverage',
          enum: ['Yes', 'No', 'Not Set'],
        },
        wind_region: {
          type: 'string',
          description: 'Wind region of the site',
        },
        power_factor: {
          type: 'number',
          description: 'Power factor of the site, between 0.0 and 1.0',
        },
      },
      required: ['project_id'],
      additionalProperties: false,
    },
    type: 'function',
  },
  {
    name: 'create_note_or_task',
    description:
      "Create a note, task or appointment on a project and optionally assign it to team members. For Tasks, at least one team member must be assigned, and the task_status must be set to 1 (Incomplete). Tasks that are scheduled for a specific date can have a start and end time. Tasks which have a deadline should use the 'end' date to record the deadline. For Appointments, the start date/time is required.",
    parameters: {
      type: 'object',
      properties: {
        team_members: {
          type: 'array',
          items: {
            type: 'integer',
          },
          description: 'List of team member role IDs to assign the task to.',
        },
        notify_team_members: {
          type: 'array',
          items: {
            type: 'integer',
          },
          description: 'List of team member role IDs to notify.',
        },
        form_config: {
          type: 'integer',
          description: 'Form configuration ID',
          //   enum: [2, 3, 4, 6],
          //   enumDescriptions: {
          //     '2': 'Project Action',
          //     '3': 'Task',
          //     '4': 'Special Action',
          //     '6': 'Note',
          //   },
        },
        start: {
          type: ['string', 'null'],
          description:
            'Task start date/time in ISO format. Only required for a) tasks with a deadline b) event that has a specified start date & time. Datetime should be specified in UTC so try to use APP_STATE.timezone_offset_hours to convert from local timezone to UTC.',
        },
        end: {
          type: ['string', 'null'],
          description:
            'Task end date/time in ISO format. Only required for an event that has a specified start date & time. Datetime should be specified in UTC so try to use APP_STATE.timezone_offset_hours to convert from local timezone to UTC.',
        },
        project_id: {
          type: 'integer',
          description: 'Project ID',
        },
        event_type_id: {
          type: 'integer',
          description:
            'Event type ID. If it is not clear what the event type is, there is no need to clarify with the user, just use: 29 (Other).',
          //   enum: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 40, 41, 42],
          //   enumDescriptions: {
          //     '20': 'Sales Call',
          //     '21': 'Call (outbound, no answer)',
          //     '22': 'Call (inbound)',
          //     '23': 'Email (outbound)',
          //     '24': 'Email (inbound)',
          //     '25': 'SMS',
          //     '26': 'Instant Message',
          //     '27': 'Meeting',
          //     '28': 'Appointment',
          //     '29': 'Other',
          //     '30': 'Busy',
          //     '40': 'System Install',
          //     '41': 'Maintenance Visit',
          //     '42': 'Site Visit',
          //   },
        },
        task_status: {
          type: 'integer',
          description:
            "Task status ID. To track this as a task which needs to be completed, set to 1. To record this as a note that doesn't need to be marked as completed, set to 0. If already completed, set to 2.",
          //   enum: [0, 1, 2],
          //   enumDescriptions: {
          //     '0': 'Not Tracked',
          //     '1': 'Incomplete',
          //     '2': 'Complete',
          //   },
        },
        notes: {
          type: 'string',
          description: 'Task notes. Empty string is acceptable if no notes are needed.',
        },
      },
      required: [
        'team_members',
        'notify_team_members',
        'form_config',
        'project_id',
        'event_type_id',
        'task_status',
        'notes',
      ],
      additionalProperties: false,
    },
    type: 'function',
  },
]
